export const IconUp = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="iconamoon:arrow-up-2-bold">
      <path
        id="Vector"
        d="M17 14L12 9L7 14"
        stroke="#808080"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const IconDown = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="iconamoon:arrow-up-2-bold">
      <path
        id="Vector"
        d="M7 10L12 15L17 10"
        stroke="#808080"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
